module.exports = __webpack_public_path__ + "static/img/warp_bg.e8c76fc2.png";